import { createContext, useContext, useLayoutEffect, useState, type ReactNode } from "react";
import type { Crumb } from "@offsilo/ui/breadcrumbs";

/** Pages tell the shell what goes in the topbar: the breadcrumb and the page's topbar actions. */
type Chrome = { crumbs: Crumb[]; actions?: ReactNode };
const Ctx = createContext<{ chrome: Chrome; setChrome: (c: Chrome) => void }>({ chrome: { crumbs: [] }, setChrome: () => {} });

export function ChromeProvider({ children }: { children: ReactNode }) {
  const [chrome, setChrome] = useState<Chrome>({ crumbs: [] });
  return <Ctx.Provider value={{ chrome, setChrome }}>{children}</Ctx.Provider>;
}

export const useChrome = () => useContext(Ctx).chrome;

/** Set the topbar for this page. Pass stable values (or memoise them); the React Compiler handles most cases. */
export function usePageChrome(crumbs: Crumb[], actions?: ReactNode) {
  const { setChrome } = useContext(Ctx);
  const key = crumbs.map((c) => `${c.id}:${c.label}`).join("|");
  // biome-ignore lint/correctness/useExhaustiveDependencies: keyed on the crumb text, actions follow the page
  useLayoutEffect(() => { setChrome({ crumbs, actions }); }, [key]);
}
